import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';

import { Vendedor } from 'src/app/aplicaciones-modulos/vdi/vendedor/model/vendedor';
import { VendedorService } from 'src/app/aplicaciones-modulos/vdi/vendedor/services/vendedor.service';

@Component({
  selector: 'app-promo-vendedor-list',
  templateUrl: './promo-vendedor-list.component.html',
  styleUrls: ['./promo-vendedor-list.component.css']
})
export class PromoVendedorListComponent implements OnInit {

  formFindVendedor: FormGroup;
  columns: TableColumn[] = [];
  itemsCounts: number[] = [10, 25, 50];
  pageSize = this.itemsCounts[0];
  selectionType = SelectionType;

  filteredRows$: Observable<Vendedor[]>;
  dataSource$: Observable<Vendedor[]>;

  selected: Vendedor[] = [];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<Vendedor[]>();

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly vendedorService: VendedorService
  ) {
    this.gridColumns();
    this.buidForm();
  }

  ngOnInit(): void {
    this.dataSource$ = this.vendedorService.getAll({ idRol: '3' }).pipe(
      tap((res) => {
        if (res.length < 0) return;
        this.filteredRows$ = this.formFindVendedor.valueChanges.pipe(
          startWith(''),
          map(({ filter, option }) => filter ? this._filter(filter, res, option) : res)
        )
      })
    );
  }

  gridColumns() {
    this.columns = [
      {
        width: 30,
        sortable: false,
        draggable: false,
        canAutoResize: false,
        resizeable: false,
        headerCheckboxable: true,
        checkboxable: true
      },
      {
        name: 'ID Vendedor',
        prop: 'id',
        width: 50,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Vendedor',
        prop: 'name',
        width: 100,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Cedula',
        prop: 'login',
        width: 300,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      }
    ];
  }

  buidForm() {
    this.formFindVendedor = this._formBuilder.group({
      filter: [''],
      option: [this.columns[0].prop]
    });
  }

  private _filter(value: string, arr: Vendedor[], scope: string) {
    return arr.filter((option) => `${option[scope]}`.toLowerCase().includes(`${value.toLowerCase()}`))
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

}
